(function () {
  class ReelSpinnerVisualDevils extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      dynamicSpinner,
      nudgeReel
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp,
        dynamicSpinner,
        nudgeReel
      );

      this._coinPotOverlays = [];
      this.multipliersActive = false;

      this.spinCount = 0;
      this.newChip = undefined;
      this.showValue = false;

      this._maxDeltaMultiplier = 1.4;
      this._maxDeltaMultiplier2 = 1.4;
      this._maxDeltaMultiplier3 = 0.62;
      this._minDeltaMultiplier = 1;

      this._deltaMultiplier = this._maxDeltaMultiplier;
      this._deltaMultiplier1 = this._maxDeltaMultiplier2;
      this._deltaMultiplier2 = this._maxDeltaMultiplier3;

      this.reelId = parseInt(reelId.replace("reel", ""));

      this._potBaseScale = 0.34;
      this._doubleBaseScale = 0.25;
      this.visibleCashOverlay;
      this._cashOverlays = [];
      this._multiplierTextOverlays = [];
      this._multiplierOverlays = [];
      this._possibleCoinValues = [1, 2, 3, 4, 5, 10];
      this._coinSymbols = [
        5, 6, 7, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
      ];
      this._gemSymbols = [8, 9, 10, 11];
      this._collectSymbols = [16, 17, 18, 19];

      this._multiplierValues = {
        5: 0.5,
        6: 1.5,
        7: 2.5,
        22: 1,
        23: 2,
      };
    }

    getReelSymbol(index) {
      let symbolData = this._reelSpinnerData.getSymbolData();
      return symbolData[index].symId;
    }

    startSlowDown() {
      if (this.reelId === 7) {
        this._deltaMultiplier = this._maxDeltaMultiplier;
        const self = this;
        this._slowDownTimer = timerManager.addTimer(
          2500,
          function (progress) {
            const multi = (self._maxDeltaMultiplier3 - self._minDeltaMultiplier) * (1 - progress);
            self._deltaMultiplier = self._minDeltaMultiplier + multi;
          },
          function () {
            self._deltaMultiplier = self._minDeltaMultiplier;
          }
        );
      }
    }

    stopSlowDown() {
      if (this.reelId === 7) {
        timerManager.stop(this._slowDownTimer);
        this._slowDownTimer = undefined;
        this._deltaMultiplier = this._maxDeltaMultiplier;
      }
    }

    createMultiplierTextOverlays() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();

      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let overlayText = resourceManager.createObject(
          "text",
          `multiplierTextOverlay:reel${this.reelId}:row${i}`,
          gfxObject.symbol.childContainer,
          {
            text: "???",
            fontDefinition: "cashCoinOnFont",
            maxWidth: 150,
            maxHeight: 54,
            anchor: 0.5,
            x: 2,
            y: 0,
          }
        );

        overlayText.visible = false;
        this._multiplierTextOverlays.push({
          overlayText,
        });
      }
    }

    createMultiplierOverlays() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();

      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let overlaySprite = resourceManager.createObject(
          "sprite",
          `multiplierOverlay:reel${this.reelId}:row${i}`,
          gfxObject.symbol.childContainer,
          {
            fileName: "Symbols/Devil Symbols/Multiplier Values/x2.png",
            anchor: 0.5,
            x: 0,
            y: 45,
          }
        );

        overlaySprite.visible = true;
        this._multiplierOverlays.push({
          overlaySprite,
        });
      }
    }

    updateSymbolIds(ids) {
      super.updateSymbolIds(ids);
      let value = 0;
      const inFS = gameController.boughtBonus || gameController.inFreeSpins;

      let stake = inFS ? gameController.getCurrentModeStake() : gameController.globalHelperGetBaseStake();

      for (let i = 0; i < ids.length; ++i) {
        let symId = ids[i];
        let overlay = this._multiplierTextOverlays[i];
        let multiplier = this._multiplierOverlays[i];
        multiplier.visible = false;
        multiplier.overlaySprite.visible = false;
        overlay.visible = false;
        overlay.overlayText.visible = false;

        if (this._coinSymbols.includes(symId)) {
          const baseValue = this._multiplierValues[symId] * stake;
          if (overlay.modifiedValue) {
            value = baseValue * overlay.modifiedValue;
          } else {
            value = baseValue;
          }
          overlay.visible = true;
          overlay.overlayText.visible = true;
          overlay.overlayText.setText(gdk.formatCurrency(value));
        } else if (this._gemSymbols.includes(symId) && multiplier.modifiedValue) {
          multiplier.overlaySprite.texture = PIXI.Texture.from(
            `graphics/Generic/Symbols/Devil Symbols/Multiplier Values/x${multiplier.modifiedValue}.png`
          );
          multiplier.visible = true;
          multiplier.overlaySprite.visible = true;
        }

        if (gameController.isRespinning || gameController.isLastRespin) {
          if (this._coinSymbols.concat(this._gemSymbols).includes(symId)) {
            this.dimSymbol(i, false, 0, false);
          } else {
            this.dimSymbol(i, true, 0, false);
          }
        }

        if (gameController.firewaveActive) {
          if (
            this._gemSymbols.includes(ids[i]) ||
            this._coinSymbols.includes(ids[i]) ||
            this._collectSymbols.includes(ids[i])
          ) {
            this.dimSymbol(i, false, 0.0, false);
          } else {
            this.dimSymbol(i, true, 0.0, false);
          }
        }
      }
    }

    dimSymbol(row, showDim, duration, dimAll = true) {
      let self = this;
      //showDim = true;
      let targetTint = showDim ? this._dimTint : 0xffffff;

      if (dimAll) {
        self._symbolGfxObjects.forEach(({ symbol }) => {
          if (duration) {
            gsap.to(symbol, {
              duration,
              pixi: { tint: targetTint },
            });
          } else {
            symbol.tint = targetTint;
          }
        });
      } else {
        super.dimSymbol(row, showDim, duration);
      }
    }

    getSymbolPosition() {
      return {
        x: this.position.x,
        y: this.position.y,
      };
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 1;

    return new ReelSpinnerVisualDevils(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp,
      gameController.dynamicSpinner,
      json.nudgeReel
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
    reelSpinnerVisual.createMultiplierTextOverlays();
    reelSpinnerVisual.createMultiplierOverlays();
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType("ReelSpinnerVisualDevils", create, initialise, getRequiredFiles);
})();
